import FEATURES_FLAGS from './constants';
import * as T from './types';

// TODO: remove isFeatureDisabled
export const isFeatureDisabled = (featureName: T.FEATURES_NAMES): boolean =>
  FEATURES_FLAGS[featureName] === false;
export const isFeatureEnabled = (featureName: T.FEATURES_NAMES): boolean =>
  !isFeatureDisabled(featureName);
